import React from 'react'

const Shipments = () => {
  return (
    <div>Shipments</div>
  )
}

export default Shipments